import { themeColors } from "@/utils/themeColors";
import { Editor } from "@knowt/editor/react";
import { memo } from "react";
import { Toolbar } from "../../../ui/Toolbar";
import { iconSizes } from "@/utils/iconProps";
import SparkleIcon from "@/components/icons/SparkleIcon";

const MemoButton = memo(Toolbar.Button);

const AIPill = ({ editor }: { editor: Editor }) => {
    return (
        <MemoButton
            onClick={() => editor.commands.aiTrigger()}
            style={{
                border: `1.5px solid`,
                borderColor: themeColors.ai,
                borderRadius: 999,
                color: themeColors.pureBlack,
                fontSize: "1.2rem",
                background: themeColors.aiGradient,
                gap: "0.8rem",
                height: "3.2rem",
                width: "9.5rem",
                marginRight: "0.4rem",
                flexShrink: 0,
                fontFamily: "var(--knowt-font-name)",
            }}>
            <SparkleIcon size={iconSizes.SM_S} />
            Ask Kai
        </MemoButton>
    );
};

export default AIPill;
